import React, { PropsWithChildren } from 'react';

interface ProfileLinkProps {
  dataCyPostfix?: string;
  handleClick: React.MouseEventHandler<HTMLButtonElement>;
}

export const ProfileLink: React.FC<PropsWithChildren<ProfileLinkProps>> = ({ children, dataCyPostfix, handleClick }) => (
  <div className="profile__toggle-wrapper">
    <button type="button" className="vl-link profile__toggle" data-cy={`profile-link-${dataCyPostfix}`} onClick={handleClick}>
      {children}
    </button>
  </div>
);

interface IProfileProps {
  naam: string;
  organisatie: string;
}

export const Profile: React.FC<IProfileProps> = ({ naam, organisatie }) => (
  <div className="profile__toggle-wrapper">
    <span className="profile__toggle" data-cy="profile">
      {naam} ({organisatie})
    </span>
  </div>
);
